module.exports = __webpack_public_path__ + "img/echoingocean_logo.6d97410a.png";